import React from 'react'
import { useParams } from 'react-router-dom'
import { NEW_ITEM_CODE } from 'utils/constants/misc'
import { useQueryParams } from 'utils/hooks/useQueryParams'
import { DeploymentPlanCreate } from 'pages/consentAndRights/deploymentPlans-v2/upsert/create/DeploymentPlanCreate'
import { DeploymentPlanEdit } from 'pages/consentAndRights/deploymentPlans-v2/upsert/edit/DeploymentPlanEdit'
import { DeploymentPlanUpsertContextProvider } from 'pages/consentAndRights/deploymentPlans-v2/upsert/context/DeploymentPlanUpsertContext'

export const DeploymentPlanUpsertContainer: React.FC = () => {
  const { code } = useParams<{ code: string }>()
  const { queries } = useQueryParams<{ duplicate?: string }>()

  const duplicate = Boolean(queries.duplicate)
  const isEditMode = code !== NEW_ITEM_CODE

  return (
    <DeploymentPlanUpsertContextProvider>
      {duplicate || !isEditMode ? <DeploymentPlanCreate /> : <DeploymentPlanEdit />}
    </DeploymentPlanUpsertContextProvider>
  )
}
